import { withInstall } from '../../utils'

import _TypeTree from './src/type-tree.vue'

export const SdTypeTree = withInstall(_TypeTree)
export default SdTypeTree

export * from './src/type-tree'
